import { render } from "./ReferencesInterface.vue?vue&type=template&id=37bf00b6&scoped=true"
import script from "./ReferencesInterface.vue?vue&type=script&lang=js"
export * from "./ReferencesInterface.vue?vue&type=script&lang=js"

import "./ReferencesInterface.vue?vue&type=style&index=0&id=37bf00b6&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf00b6"]])

export default __exports__